import { createFileRoute } from "@tanstack/react-router";
import PoliticaCookies from "@/pages/legal/PoliticaCookies";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/politica-cookies/")({
  head: () => routeHead("/politica-cookies/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PoliticaCookies />
  );
}
